export default __webpack_public_path__ + "static/media/Tasset of Indomitable Souls.25ff5b73.jpg";